import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StatusLoadingIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M15.78 13.46L12.63 11.64V5C12.63 4.65 12.35 4.38 12.01 4.38C11.67 4.38 11.39 4.66 11.39 5V12C11.39 12.22 11.51 12.43 11.7 12.54L15.16 14.54C15.45 14.71 15.84 14.61 16.01 14.31C16.18 14.01 16.08 13.63 15.78 13.46Z"
        fill={color}
      />
      <path
        d="M12.0001 23.94C11.5901 23.94 11.2501 23.6 11.2501 23.19C11.2501 22.78 11.5901 22.44 12.0001 22.44C17.7601 22.44 22.4401 17.76 22.4401 12C22.4401 6.24 17.7601 1.56 12.0001 1.56C6.24006 1.56 1.56006 6.24 1.56006 12C1.56006 12.41 1.22006 12.75 0.810059 12.75C0.400059 12.75 0.0600586 12.41 0.0600586 12C0.0600586 5.42 5.42006 0.0599976 12.0001 0.0599976C18.5801 0.0599976 23.9401 5.42 23.9401 12C23.9401 18.58 18.5801 23.94 12.0001 23.94Z"
        fill={color}
      />
      <path
        d="M7.57 21.46C7.03 21.21 6.5 20.9 6 20.55C5.66 20.31 5.19 20.39 4.96 20.73C4.72 21.07 4.8 21.54 5.14 21.77C5.71 22.17 6.31 22.52 6.93 22.81C7.3 22.98 7.75 22.83 7.93 22.45C8.11 22.07 7.94 21.63 7.57 21.45V21.46Z"
        fill={color}
      />
      <path
        d="M3.44995 17.99C3.09995 17.49 2.79995 16.97 2.53995 16.42C2.35995 16.04 1.91995 15.88 1.53995 16.06C1.15995 16.24 0.999948 16.68 1.17995 17.06C1.46995 17.68 1.81995 18.29 2.21995 18.85C2.45995 19.19 2.92995 19.27 3.25995 19.03C3.59995 18.79 3.67995 18.32 3.43995 17.99H3.44995Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

StatusLoadingIcon.displayName = 'StatusLoadingIcon';
